import { render, staticRenderFns } from "./score-details.vue?vue&type=template&id=f8696c60&scoped=true&"
import script from "./score-details.vue?vue&type=script&lang=js&"
export * from "./score-details.vue?vue&type=script&lang=js&"
import style0 from "./score-details.vue?vue&type=style&index=0&id=f8696c60&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8696c60",
  null
  
)

export default component.exports